"use strict";
/*
 * Created on 09 03 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Serialization/deserialization of {@link ProductPreferredSupplier entity}.
 *
 * @author JMe
 */


var ProductPreferredSupplierConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ProductPreferredSupplierConverter, _DataObjectConverter_);

  function ProductPreferredSupplierConverter() {
    _classCallCheck(this, ProductPreferredSupplierConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductPreferredSupplierConverter).apply(this, arguments));
  }

  return ProductPreferredSupplierConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ProductPreferredSupplierConverter = ProductPreferredSupplierConverter;